import { render, staticRenderFns } from "./CardBike.vue?vue&type=template&id=8e0294f4&scoped=true"
import script from "./CardBike.vue?vue&type=script&lang=js"
export * from "./CardBike.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8e0294f4",
  null
  
)

export default component.exports